'use client';

import CustomError from '@/views/error';

const NotFound = () => {
  return <CustomError errorCode={'404'} message="요청하신 페이지를 찾을 수 없습니다." />;
};

export default NotFound;
